import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

import  Navbar  from './components/Navbar';
import  Sidebar from './components/Sidebar';
import  Footer from './components/Footer';
import 'assets/css/layout.css';
import 'assets/css/floating-actions.css';
import  Time from './components/Time';
import Calendar from './components/Calendar';
import Pending from './components/Pending';
import SessionTimer from './components/SessionTimer';

import { connect } from "react-redux";
import * as actions_list from "redux/actions/watchListActions";
import * as actions_setting from "redux/actions/settingActions";
import * as actions_event from "redux/actions/eventActions";
import * as actions_note from "redux/actions/noteActions";
import * as actions_session from "redux/actions/sessionActions";
import * as actions_stock from "redux/actions/stockActions";
import { config } from '../../config';

// const useStyles = {
//   root: {
//     paddingTop: 56,
//     height: '100%',
//     // [theme.breakpoints.up('sm')]: {
//     //   paddingTop: 64
//     // }
//   },
//   shiftContent: {
//     paddingLeft: 240
//   },
//   content: {
//     height: '100%'
//   }
// };

const Main = props => {
  const { children } = props;
  const location = useLocation();
  const [isCollapsed, setIsCollapsed] = React.useState(false);
  const [search, setSearch] = useState("");
  const searchTimeoutRef = useRef(null);
  const { data, user_id, token, lang } = props;
  const { loadListWatchList, loadItem, loadListNotes } = props;
  const { resetList } = props;

  useEffect(() => {
    setSearch("");
    loadListWatchList(user_id, token);
    loadItem(user_id, token);//setting
    loadListNotes({ id: user_id }, token);
  }, [data, user_id, token, loadListWatchList, loadItem, loadListNotes]);

  useEffect(() => {
    if (!config.tradeService.active || !user_id) {
      return undefined;
    }
    props.initConextionSocket({ user_id, token });
    return () => {
      props.closeConextionSocket();
    };
  }, [user_id, token]);

  useEffect(() => {
    const handleClick = (event) => {
      if (event.target.closest('.navbar-search')) {
        return;
      }
      setSearch("");
      resetList();
    };

    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        setSearch("");
        resetList();
      }
    };

    document.addEventListener('click', handleClick);
    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('click', handleClick);
      document.removeEventListener('keydown', handleEscape);
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, [resetList]);

  useEffect(() => {
    setSearch('');
    resetList();
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }
  }, [location.pathname, resetList]);

  const onActive = () => {
    // keepalive callback for SessionTimer
  }

  const onIdle = () => {
    props.Logout();
    props.closeConextionSocket();
    // console.log("Idle");
    // props.history.push('/login');
  }

  const onToggle = () => {
        // Implement the logic to toggle the sidebar
        // This could involve updating a state variable or calling a function passed via props
        // For example, if you have a state variable called 'collapsed', you can toggle it like this:
        setIsCollapsed(!isCollapsed);
        // console.log('Sidebar toggled. Current state:', !isCollapsed);
  }

  const Search = (value) => {
    setSearch(value);

    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    if (!value.trim()) {
      resetList();
      return;
    }

    searchTimeoutRef.current = setTimeout(() => {
      props.searchList({ id: props.user_id, search: value.trim() }, props.token);
    }, 300);
  };

  const onClickClear = () => {
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }
    setSearch("");
    resetList();
  };

  const onClickStock = () => {
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }
    setSearch("");
    resetList();
  };

  return (
    <div className="layout">
      <SessionTimer onActive={onActive} onIdle={onIdle} timeOutInterval={1800 * 1000} />
      <Navbar
        onSidebarOpen={onToggle}
        Search={(e) => Search(e.target.value)}
        onClickClear={onClickClear}
        onClickStock={onClickStock}
        search_text={search}
        list={props.list}
        loading={props.loading}
      />
      <div className="layout-body">
        <Sidebar isCollapsed={isCollapsed} onToggle={onToggle} />
        <div className="layout-content">
          <main className="main-content">
            {children}
          </main>
          <Footer />
        </div>
      </div>
      <div className="main-floating-actions">
        <Time />
        <Pending />
        <Calendar />
      </div>
    </div>
  );
};

Main.propTypes = {
  children: PropTypes.node
};

function mapStateToProps(reducer) {
  // console.log(reducer);
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.token,

    market: reducer.session.auth.market,
    lang: reducer.i18n.locale,

    data: reducer.dashboard.data,

    list: reducer.stock.list,
    error: reducer.stock.error,
    loading: reducer.stock.loading,
  };
}


const mapDispatchToProps = dispatch => ({
  loadListWatchList: (user_id, token) =>
    dispatch(actions_list.loadList({ user_id, token })),
  loadItem: (user_id, token) =>
    dispatch(actions_setting.loadItem({ user_id, token })),


  loadListNotes: (params, token) =>
    dispatch(actions_note.loadList({ params, token })),

  initConextionSocket: (user_id, token) =>
    dispatch(actions_event.initConextionSocket({ user_id, token })),
  closeConextionSocket: () =>
    dispatch(actions_event.closeConextionSocket({})),
  Logout: () =>
    dispatch(actions_session.logout({})),
   searchList: (params, token) =>
      dispatch(actions_stock.searchList({ params, token })),
   resetList: () =>
           dispatch(actions_stock.resetList({})),
});
export default connect(mapStateToProps, mapDispatchToProps)(Main);


/**
 * () => { setIsActive(true) }
 * () => { setIsActive(false) }
 */